import { COLUMN_ACCESS, COLUMN_CATEGORY, COLUMN_COMPANY, COLUMN_DEPARTMENT, COLUMN_DISPLAY_NAME, COLUMN_ENABLED, COLUMN_FIRST_NAME, COLUMN_FRI, COLUMN_GENDER, COLUMN_LAST_NAME, COLUMN_MON, COLUMN_SAT, COLUMN_SECOND_NAME, COLUMN_SITE, COLUMN_SUFFIX, COLUMN_SUN, COLUMN_THU, COLUMN_TITLE, COLUMN_TUE, COLUMN_UNIQUE_IDENTIFIER, COLUMN_WED } from "../../constants/column-types";
import { FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_PROFILE, FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";
import { ColumnFormattingClasses } from "./constants/ColumnFormattingClasses";

const AbsenteeismCurrentWeekReportColumns : TableColumn[] = [
    {
        heading: "Unique Identifier",
        accessor: "uniqueIdentifier",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER
    },
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 2,
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 4,
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 5,
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 6,
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        id: 7,
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 8,
        active: true,
        searchOnName: "departmentId",
        lookupName: "department",
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: 'department'
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 9,
        searchOnName: "companyId",
        lookupName: "company",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: 'company'
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 10,
        searchOnName: "profileId",
        lookupName: "category",
        active: false,
        translationKey: "category",
        columnId: COLUMN_CATEGORY,
        filterId: FILTER_PROFILE,
        settingDataName: 'profile'
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 11,
        searchOnName: "site.id",
        lookupName: "site",
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site'
    },
    {
        heading: "Mon",
        accessor: "monday",
        isNumeric: false,
        id: 12,
        active: true,
        translationKey: "mon",
        valueFormatting: (value) => {
            const valueFormats = {
                Absent: ColumnFormattingClasses.categoryRed
            }
            return valueFormats[value];
        },
        columnId: COLUMN_MON
    },
    {
        heading: "Tue",
        accessor: "tuesday",
        isNumeric: false,
        id: 13,
        active: true,
        translationKey: "tue",
        valueFormatting: (value) => {
            const valueFormats = {
                Absent: ColumnFormattingClasses.categoryRed
            }
            return valueFormats[value];
        },
        columnId: COLUMN_TUE
    },
    {
        heading: "Wed",
        accessor: "wednesday",
        isNumeric: false,
        id: 14,
        active: true,
        translationKey: "wed",
        valueFormatting: (value) => {
            const valueFormats = {
                Absent: ColumnFormattingClasses.categoryRed
            }
            return valueFormats[value];
        },
        columnId: COLUMN_WED
    },
    {
        heading: "Thu",
        accessor: "thursday",
        isNumeric: false,
        id: 15,
        active: true,
        translationKey: "thu",
        valueFormatting: (value) => {
            const valueFormats = {
                Absent: ColumnFormattingClasses.categoryRed
            }
            return valueFormats[value];
        },
        columnId: COLUMN_THU
    },
    {
        heading: "Fri",
        accessor: "friday",
        isNumeric: false,
        id: 16,
        active: true,
        translationKey: "fri",
        valueFormatting: (value) => {
            const valueFormats = {
                Absent: ColumnFormattingClasses.categoryRed
            }
            return valueFormats[value];
        },
        columnId: COLUMN_FRI
    },
    {
        heading: "Sat",
        accessor: "saturday",
        isNumeric: false,
        id: 17,
        active: true,
        translationKey: "sat",
        valueFormatting: (value) => {
            const valueFormats = {
                Absent: ColumnFormattingClasses.categoryRed
            }
            return valueFormats[value];
        },
        columnId: COLUMN_SAT
    },
    {
        heading: "Sun",
        accessor: "sunday",
        isNumeric: false,
        id: 18,
        active: true,
        translationKey: "sun",
        valueFormatting: (value) => {
            const valueFormats = {
                Absent: ColumnFormattingClasses.categoryRed
            }
            return valueFormats[value];
        },
        columnId: COLUMN_SUN
    },
    {
        heading: "Gender",
        accessor: "gender",
        isNumeric: false,
        id: 19,
        active: false,
        translationKey: "gender",
        columnId: COLUMN_GENDER
    }
];

export default AbsenteeismCurrentWeekReportColumns;
